import { z } from 'zod';
import { Price } from './Price.schema';

export const AvailabilityFormSchema = z
  .object({
    delayAfter: z.number().optional(),
    endTime: z.string(),
    experienceId: z.number(),
    price: Price,
    startTime: z.string(),
    type: z.string(),
    optionId: z.number(),
    optionGroupId: z.number().or(z.string()),
    dayNumber: z.number(),
    visitDate: z.string(),
    staff: z.array(z.string()).optional(),
    rooms: z.array(z.string()).optional(),
  })
  .optional();

export type AvailabilityForm = z.infer<typeof AvailabilityFormSchema>;
